<div id="goto-url-container">
    <a #link class="cursor-pointer" (click)="onGoToUrlClick()" tabindex="0"></a>
</div>
